module.exports = __webpack_public_path__ + "static/img/pruning.bc8041a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/pruning.jpg
// module id = XIAZ
// module chunks = 1